export default __webpack_public_path__ + "static/media/512_경북이미지_참가등록 복사.86313fa3.jpg";